export default {
    loadData(state, req) {
        let { data } = req;
        if (!data) return;
        for (let key of Object.keys(data)) state[key] = data[key];
    },
    loadSearch(state, req) {
        let { item } = req;
        if (typeof (item) !== "object") return;
        state.search[item.keyword] = item;
    },
    loadError(_, req) {
        console.log("chrome.on.error", req);
    },
};



// WEBPACK FOOTER //
// src/store/chrome/mutations.js